<template>
    <div class="games">
        <slot v-if="isMobile">
            <Game>
                <template slot="title">10 Burning Heart</template>
                <template slot="img"><img src="https://eu-static.casinomodules.co/images/egt_desktop/543.png"></template>
                <template slot="play">
                    <a @click="runGame({id: '56088', device: isMobile})" href="javascript:;" class="button primary">Gerçek Oyna</a>
                </template>
            </Game>
            <Game>
                <template slot="title">100 Super Dice</template>
                <template slot="img"><img src="https://eu-static.casinomodules.co/images/egt_desktop/557.png"></template>
                <template slot="play">
                    <a @click="runGame({id: '56102', device: isMobile})" href="javascript:;" class="button primary">Gerçek Oyna</a>
                </template>
            </Game>
            <Game>
                <template slot="title">40 Mega Clover</template>
                <template slot="img"><img src="https://eu-static.casinomodules.co/images/egt_desktop/550.png"></template>
                <template slot="play">
                    <a @click="runGame({id: '56095', device: isMobile})" href="javascript:;" class="button primary">Gerçek Oyna</a>
                </template>
            </Game>
            <Game>
                <template slot="title">Almighty Ramses II</template>
                <template slot="img"><img src="https://eu-static.casinomodules.co/images/egt_desktop/573.png"></template>
                <template slot="play">
                    <a @click="runGame({id: '56118', device: isMobile})" href="javascript:;" class="button primary">Gerçek Oyna</a>
                </template>
            </Game>
            <Game>
                <template slot="title">100 Dice</template>
                <template slot="img"><img src="https://eu-static.casinomodules.co/images/egt_desktop/599.png"></template>
                <template slot="play">
                    <a @click="runGame({id: '56144', device: isMobile})" href="javascript:;" class="button primary">Gerçek Oyna</a>
                </template>
            </Game>
        </slot>

        <div class="game" v-if="!isMobile">
            <div class="box">
                <div class="image">
                    <img src="https://eu-static.casinomodules.co/images/egt_desktop/543.png"/>
                </div>
                <div class="info">
                    <h6>10 Burning Heart</h6>
                    <p>EGT</p>
                    <a href="javascript:;" @click="runGame({id: '56088', device: isMobile})"  class="button secondary">Hemen Oyna</a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://eu-static.casinomodules.co/images/egt_desktop/557.png"/>
                </div>
                <div class="info">
                    <h6>100 Super Dice</h6>
                    <p>EGT</p>
                    <a href="javascript:;" @click="runGame({id: '56102', device: isMobile})"  class="button secondary">Hemen Oyna</a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://eu-static.casinomodules.co/images/egt_desktop/550.png"/>
                </div>
                <div class="info">
                    <h6>40 Mega Clover</h6>
                    <p>EGT</p>
                    <a href="javascript:;" @click="runGame({id: '56095', device: isMobile})"  class="button secondary">Hemen Oyna</a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://eu-static.casinomodules.co/images/egt_desktop/573.png"/>
                </div>
                <div class="info">
                    <h6>Almighty Ramses II</h6>
                    <p>EGT</p>
                    <a href="javascript:;" @click="runGame({id: '56118', device: isMobile})"  class="button secondary">Hemen Oyna</a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://eu-static.casinomodules.co/images/egt_desktop/599.png"/>
                </div>
                <div class="info">
                    <h6>100 Dice</h6>
                    <p>EGT</p>
                    <a href="javascript:;" @click="runGame({id: '56144', device: isMobile})"  class="button secondary">Hemen Oyna</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { mapActions } from 'vuex'
    import Game from './Game'
    export default{
        data(){
            return{

            }
        },
        components:{
            Game
        },
        methods:{
            runGame(payload){
                if(this.$route.name != 'Slot'){
                    this.$router.push({ name: 'Slot' })
                } 
                if(!this.$auth()){
                this.$emit('loginModal', true);
                return false;
                }else{
                this.$store.dispatch('slot/runGame', payload)
                }
            }
        },
        computed:{
        }
    }
</script>